import type { IAppEnvConfig } from '#types/envs.types';

export const apiFetchAppEnvConfig = async (): Promise<IAppEnvConfig> => {
  const response = await fetch('/env.json');

  const data = await response.json();

  return data;
};
